import { ol_Feature } from "@omnia/exports/openlayers"
import { DatalayersMap, fields } from "../../omnia"

export class CroppingStyle extends fields.map.layers.CroppingLayerStyle {


    static setup(map: DatalayersMap) {

        const { croppingLayer: layer } = map

        const initStyle = layer.styleProvider

        const style = new CroppingStyle(layer)
        layer.styleProvider = s => style.getLayerStyleFunction(s)

        return {
            style,
            dispose: () => {
                layer.styleProvider = initStyle
                layer.refresh()
            }
        }

    }


    private _selectedFields: Set<number>

    private constructor(layer: fields.map.layers.CroppingLayer) {
        super(layer)
    }

    public setSelectedFields(fieldIds: number[]) {
        this._selectedFields = new Set(fieldIds)
        this.layer.refresh()
    }

    protected getCroppingColor(feature: ol_Feature, selected: boolean, opacity: number) {

        const field = feature.get("data")

        if (fields.isFieldViewModel(field)) {

            if (this._selectedFields?.has(field.fieldId)) {
                return "transparent"
            }

        }

        return super.getCroppingColor(feature, selected, opacity)

    }

}
